import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from 'src/app/services/token.service';
import { IColumModel, ColumnModel } from 'src/app/shared/tabela-crud/model/IColum.model';
import { EventoAcaoExtra } from 'src/app/shared/tabela-crud/model/tabela-eventos.model';
import { TipoColunaEnum } from 'src/app/shared/tabela-crud/model/tipo-coluna.enum';
import { AcoesExtraEnum } from 'src/app/shared/tabela-crud/tabela-acoes.enum';
import { Assessor } from '../../../model/assessor';
import { DashboardEscritorioCoreService } from '../../../core/dashboard-escritorio-core.service';

@Component({
  selector: 'app-assessores',
  templateUrl: './assessores.component.html',
  styleUrls: ['./assessores.component.css']
})
export class AssessoresComponent implements OnInit {

  colunasTabela: IColumModel[] = [
    new ColumnModel('nome', 'Nome'),
    new ColumnModel('statusCadastro', 'Status', TipoColunaEnum.Tag),
  ];

  uuidEscritorio!: string;
  assessoresEscritorio: Assessor[];
  quantidadeAssessores: number = 0;
  quantidadeAssessoresAtivos: number = 0;

  constructor(
    private tokenService: TokenService,
    private router: Router,
    private dashboardEscritorioCore: DashboardEscritorioCoreService
  ) { }

  ngOnInit(): void {
    this.uuidEscritorio = this.tokenService.carregarUsuarioLogado()?.uuidTipoUsuario;

    if (this.uuidEscritorio) {
      this.dashboardEscritorioCore.getQuantidadeAssessores(this.uuidEscritorio).subscribe(
        res => this.quantidadeAssessores = res.dados[0].quantidadeAssessores
      );

      this.dashboardEscritorioCore.getAssessoresPorEscritorio(this.uuidEscritorio).subscribe(
        res => {
          let assessores = res.dados[0].content;
          this.assessoresEscritorio = assessores;
          assessores.filter(assessor => {
            if (assessor.statusCadastro) {
              this.quantidadeAssessoresAtivos ++;
            }
          });
        }
      )
    }
  }

  redirecionarDashboardAssessor() {
    this.router.navigate([`dashboard/assessor/rodadas-ativas`]);
  }

  executarAcaoExtra(evento: EventoAcaoExtra<any>): void {
    if (evento.acaoExtra == AcoesExtraEnum.Dashboard) {
      this.redirecionarDashboardAssessor();
    }
  }
}
